import React from "react";
import { sbEditable } from "@storyblok/storyblok-editable";
import FluidImage from "src/utils/FluidImage";
import { BoldColour } from "src/utils/ColourUtilities";
import RichText from "src/utils/RichText";
import Button from "src/components/Button";
import Heading from "src/components/Heading";

const HeroSlide = ({ blok }) => {
  return (
    <div
      className="relative bg-darkgrey !flex flex-col"
      {...sbEditable(blok)}
    >
      <div className="absolute inset-0">
        <FluidImage
          fadeIn={false}
          loading="eager"
          className="w-full h-full object-cover"
          image={blok.background_image}
          placeholder="https://via.placeholder.com/1920x1080?text=1920x1080+(double+if+needed)"
        />
        <div
          className="absolute inset-0 bg-darkgrey opacity-80"
          aria-hidden="true"
        ></div>
      </div>
      <div className="relative flex flex-col md:flex-row justify-start mx-auto py-12 lg:py-24 sm:py-32 px-6 lg:px-16 w-full lg:max-w-[1440px]">
        <div className="relative lg:w-[500px] text-white">
          <Heading
            size="h1"
            className={`block leading-[3.2rem] sm:leading-[3.7rem] lg:leading-[4.9rem] text-6xl sm:text-7xl ${BoldColour(
              blok.colour
            )}`}
          >
            <RichText>{blok.title}</RichText>
          </Heading>
        </div>
      </div>
      <div className="flex flex-col md:flex-row justify-end items-end mt-auto">
        <div className="relative w-10/12 md:w-3/4 lg:w-1/2 text-white flex items-end bg-darkgrey">
          <div className="py-6 sm:py-10 px-6 lg:px-24">
            <p className="mb-5 text-sm max-w-prose">{blok.description}</p>
            <Button
              className="bg-red hover:bg-darkred text-white uppercase sm:text-[1.3rem] !text-lg sm:px-[30px] px-[20px] sm:py-[14px] py-[9px] "
              target={blok.button_target.cached_url}
            >
              {blok.button_label}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSlide;
